<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  import { parseUrl } from "$lib/utils/helpers";
  import PostCardSubheading from "$lib/molecules/newsroom/helper/PostCardSubheading.svelte";
  import Button from "$lib/atoms/Button.svelte";
  import optimizeImage, { aspectRatio } from "$lib/utils/optimizeImage";

  import { ButtonColor, IconType } from "$types/atoms";

  export let post: any;

  let titleElementId = `post-${post.full_slug.split("/").pop()}`;
</script>

{#if post && post.full_slug}
  <a
    href={parseUrl(`/${post.full_slug}`)}
    class="flex flex-col !p-0 lg:flex-col-reverse lg:!p-0 bg-sand rounded-md overflow-hidden lg:row-span-2 lg:gap-[2rem] no-underline group"
  >
    <div class="lg:flex lg:gap-10 lg:items-end lg:justify-between">
      <div class="lg:flex hidden lg:pl-[50px] lg:pb-[50px]">
        <ArrowLink
          class="reduced hover-red-bg white-arrow"
          noText={true}
          labelElement={titleElementId}
        />
      </div>
      <div class="xl:max-w-[402px] sm:shrink-0 w-full lg:w-[73%] xl:w-full">
        {#if post.content?.mastheadImage?.filename}
          <img
            src={optimizeImage(post.content.mastheadImage.filename)}
            alt={post.content.mastheadImage.alt}
            class="ml-auto"
            style={aspectRatio(post.content.mastheadImage.filename)}
            loading="lazy"
          />
        {/if}
      </div>
    </div>
    <div class="flex-1 p-8 sm:py-[40px] lg:pb-0">
      <div class="w-full sm:mx-auto flex flex-col justify-between h-full gap-8">
        <div>
          <h4 class="type:h5-eyebrow text-charcoal/50" id={titleElementId}>
            {@html post.category_name}
          </h4>
          <h3 class="type:body-title text-charcoal mt-4 md:mt-6">
            {@html post?.content?.previewHeading || post.name}
          </h3>
        </div>
        <div class="lg:hidden">
          <Button
            textOutside={true}
            color={ButtonColor.WHITE}
            icon={IconType.ARROW_RIGHT}
            reduced
          />
        </div>
      </div>
    </div>
  </a>
{/if}
